// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mx-context-menu-item span {\n  color: inherit;\n}\n#mx-menu-default-container {\n  z-index: 1060 !important;\n}\n", ""]);
// Exports
module.exports = exports;
